import { useEffect } from 'react';

import { echo } from 'services/echo';

export interface NotificationPayload {
    type: string;
    rfq_id?: number;
    rfx_invite_id?: number;
    [key: string]: unknown;
}

const useUserNotifications = (
    userId: number | undefined,
    onNotification: (payload: NotificationPayload) => void
): void => {
    useEffect(() => {
        if (!userId || !echo) {
            return;
        }

        const channelName = `App.Models.Auth.User.${userId}`;
        const channel = echo.private(channelName);

        channel.notification((payload: NotificationPayload) => {
            onNotification(payload);
        });

        return () => {
            echo?.leave(channelName);
        };
    }, [userId, onNotification]);
};

export { useUserNotifications };
